module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Nicolas Dutour | Dév Frontend","short_name":"Nicolas Dutour","description":"Portfolio de Nicolas Dutour qui décrit les compétences en Html, Css, Javascript, React, Redux, NetxsJs, Angular, Gatsby, Bootstrap, Material UI, Strapi, Contenful, Shadcn, Tailwind. Il présente aussi mes différents projets réalisés.","lang":"fr","display":"standalone","icon":"src/images/icon.png","start_url":"/","background_color":"#202330","theme_color":"#b12e1f","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"53aa06cf17e4239d0dba6ffd09854e02"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/","/about/","/skills/","/projects/"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
